/**
 * Toast configuration utilities for API requests.
 * @see TOAST_CONFIG.md for usage documentation.
 */

export const SILENT_CONFIG_KEY = '__bfbSilent';

export const withSilent = () => ({
  [SILENT_CONFIG_KEY]: true,
});

export const isSilent = config => config?.[SILENT_CONFIG_KEY] === true;

export const HANDLED_STATUSES_CONFIG_KEY = '__bfbHandledStatuses';

/**
 * Declares response statuses the caller shows its own message for, so the generic
 * error toast is skipped for them. Every other status keeps the default behaviour,
 * as do the "Saving..." and "Data saved" toasts.
 *
 * @param {number[]} statuses HTTP statuses handled by the caller
 */
export const withHandledStatuses = statuses => ({
  [HANDLED_STATUSES_CONFIG_KEY]: statuses,
});

export const isHandledStatus = (config, status) =>
  (config?.[HANDLED_STATUSES_CONFIG_KEY] || []).includes(status);
